import { useState } from 'react';

const  TestingServices=()=> {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [flippedCard, setFlippedCard] = useState(null);
  
  // Define color constants with hex codes
  const COLORS = {
    primary: "#6b2c91",
    secondary: "#f3e8ff",
    text: "#333333",
    lightText: "#666666",
    background: "#f9fafb",
    cardBorder: "#e9d5ff",
    cardBackBg: "#f3e8ff",
    headingBg: "#f0e6ff",
    headingUnderline: "#9333ea"
  };
  
  const cards = [
    {
      id: 1,
      title: "Exploratory Testing",
      icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/ICONS/exploratory%20testing.png?updatedAt=1747029616670",
      description: "Unstructured testing approach where testers explore the application to identify defects. Focuses on discovery and learning without predefined test cases."
    },
    {
      id: 2,
      title: "Automation Testing",
      icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/ICONS/Automation%20Testing%20icon.png?updatedAt=1747029616731",
      description: "Using specialized tools to execute test cases and compare actual outcomes with expected outcomes. Increases efficiency, reliability, and test coverage."
    },
    {
      id: 3,
      title: "Functional Testing",
      icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/ICONS/Functional%20testing.png?updatedAt=1747029616854",
      description: "Validating that the system performs according to specified requirements. Ensures each function of the application operates as expected."
    },
    {
      id: 4,
      title: "Mobile App Testing",
      icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/ICONS/mobile%20app%20testing.png?updatedAt=1747029616736",
      description: "Specialized testing for mobile applications across different devices, OS versions, and network conditions. Includes usability, performance, and compatibility testing."
    },
    {
      id: 5,
      title: "UI/UX Testing",
      icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/ICONS/UIUX%20Testing.png?updatedAt=1747029620245",
      description: "Creating comprehensive test strategies and plans that outline testing scope, approach, resources, schedule, and deliverables for efficient testing execution."
    },
    {
      id: 6,
      title: "Performance Testing",
      icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/ICONS/Performance%20load%20testing.png?updatedAt=1747029616911",
      description: "Evaluating how a system performs under various conditions. Measures responsiveness, stability, scalability, and resource usage under expected workloads."
    },
    {
      id: 7,
      title: "UAT/Release Auditing",
      icon:"https://ik.imagekit.io/kqumni8l2/Testing%20page/ICONS/UAT%20Release%20Auditing.png?updatedAt=1747029616722",
      description: "Verifying data collection, tracking implementation, and reporting accuracy. Ensures that analytical tools correctly capture user interactions and business metrics."
    },
    {
      id: 8,
      title: "Device Fragmentation Testing",
      icon: "https://ik.imagekit.io/kqumni8l2/Testing%20page/ICONS/Device%20Fragmantation.png?updatedAt=1747029616398",
      description: "Testing how multiple components or systems work together. Validates that integrated units function correctly and that data flows properly between them."
    }
  ];

  const handleCardClick = (id) => {
    if (flippedCard === id) {
      setFlippedCard(null);
    } else {
      setFlippedCard(id);
    }
  };

  const handleCardHover = (id) => {
    setHoveredCard(id);
  };

  const handleCardLeave = () => {
    setHoveredCard(null);
  };

  return (
    <div style={{ backgroundColor: COLORS.background }} className="min-h-screen px-4 sm:px-6 lg:px-8 ">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 inline-block relative">
            <span className="relative z-10">
              <span 
                style={{ color: COLORS.primary }} 
                className="text-3xl md:text-4xl relative"
              >
                Demonstrating Unmatched 
                <span 
                  className="absolute bottom-0 left-0 w-full h-3" 
                  style={{ backgroundColor: COLORS.headingUnderline, opacity: 0.3 }}
                ></span>
              </span>
              <span style={{ color: COLORS.text }} className='text-2xl'> Speed Optimization Capabilities</span>
            </span>
          </h1>
          <div 
            className="mx-auto max-w-lg rounded-lg py-2 px-4 mb-6"
            style={{ backgroundColor: COLORS.headingBg }}
          >
            <p style={{ color:"black" }} className="text-xl text-center">
              Highlighting our Capabilities and Expertise
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((card) => (
            <div 
              key={card.id}
              className="relative h-64 sm:h-72 cursor-pointer"
              onClick={() => handleCardClick(card.id)}
              onMouseEnter={() => handleCardHover(card.id)}
              onMouseLeave={handleCardLeave}
            >
              <div 
                className={`w-full h-full duration-700 preserve-3d ${
                  flippedCard === card.id || hoveredCard === card.id ? 'rotate-y-180' : ''
                }`}
              >
                {/* Front of card */}
                <div 
                  style={{ 
                    backgroundColor: "#FFFFFF", 
                    borderColor: COLORS.cardBorder,
                    boxShadow: hoveredCard === card.id ? '0 10px 15px -3px rgba(107, 44, 145, 0.2)' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                  }} 
                  className="absolute w-full h-full backface-hidden rounded-lg border flex flex-col items-center justify-center p-6 transition-all"
                >
                  <div style={{ color: COLORS.primary }} className="mb-4">
                   <img src= {card.icon} alt= {card.title} className='h-32' style={{ color: COLORS.primary }}  />
                  </div>
                  <h3 style={{ color: COLORS.primary }} className="text-xl font-semibold text-center">
                    {card.title}
                  </h3>
                </div>

                {/* Back of card */}
                <div 
                  style={{ 
                    backgroundColor: COLORS.cardBackBg, 
                    borderColor: COLORS.cardBorder,
                    boxShadow: hoveredCard === card.id ? '0 10px 15px -3px rgba(107, 44, 145, 0.2)' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                  }} 
                  className="absolute w-full h-full backface-hidden rotate-y-180 rounded-lg border flex flex-col items-center justify-center p-6"
                >
                  <h3 style={{ color: COLORS.primary }} className="text-xl font-semibold mb-3">
                    {card.title}
                  </h3>
                  <p style={{ color: COLORS.lightText }} className="text-center">
                    {card.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default TestingServices;
// Add required CSS for 3D effect
const style = document.createElement('style');
style.textContent = `
  .preserve-3d {
    transform-style: preserve-3d;
    transition: transform 0.6s ease;
  }
  .backface-hidden {
    backface-visibility: hidden;
  }
  .rotate-y-180 {
    transform: rotateY(180deg);
  }
`;
document.head.appendChild(style);